import { render, staticRenderFns } from "./BookingRequestCard.vue?vue&type=template&id=50e59ca0&lang=pug&"
import script from "./BookingRequestCard.vue?vue&type=script&lang=ts&"
export * from "./BookingRequestCard.vue?vue&type=script&lang=ts&"
import style0 from "./BookingRequestCard.vue?vue&type=style&index=0&id=50e59ca0&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports